"use client";

export { default } from "../(main)/error";
